import { styled } from '@zenbusiness/zui/styles';
import { Link } from 'react-router-dom';

const LinkStyles = () => ({
  textDecoration: 'none',
  '&:focus, &:hover, &:visited, &:link, &:active': {
    textDecoration: 'none'
  }
});

export const LinkStyled = styled(Link)(LinkStyles);
